// src/setupReadableStream.js

if (typeof window !== "undefined" && typeof window.process === "undefined") {
  window.process = {
    env: { DEBUG: undefined },
    nextTick: require("next-tick"),
    versions: {},
  };
}
